<template>
  <div>
    <div class="vx-row mb-4">
      <div class="vx-col md:w-1/2 w-full">
        <h2>{{ $t("popUps.PopUpList") }}</h2>
      </div>
      <div class="vx-col md:w-1/2 w-full">
        <div class="text-right">
          <vs-button
            @click="setpopupNewPopUp(true)"
            color="primary"
            type="border"
            >{{ $t("popUps.NewPopUp") }}</vs-button
          >
          <vs-popup
            :title="$t('popUps.NewPopUp')"
            class="popup-w-900"
            :active.sync="popupNewPopUp"
          >
            <new-pop-up ref="newPopUpModal"></new-pop-up>
          </vs-popup>
        </div>
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        <table-data-grid :data="itemsDataGrid" :dataColumns="dataColumns">
          <template v-slot:actions="slotProps">
            <div class="dropdown-button-container">
              <vs-button
                class="btnx"
                type="filled"
                color="primary"
                @click="seePopUp(slotProps.item.id)"
              >
                {{ $t("Ver") }}
              </vs-button>
              <vs-dropdown vs-trigger-click>
                <vs-button
                  class="btn-drop"
                  type="filled"
                  icon="expand_more"
                ></vs-button>
                <vs-dropdown-menu>
                  <ul style="min-width: 12rem">
                    <li>
                      <span
                        @click="editPopUp(slotProps.item.id)"
                        class="cursor-pointer py-3 px-4 block text-primary hover:bg-primary hover:text-white w-full"
                      >
                        <feather-icon icon="EditIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Editar") }}</span>
                      </span>
                    </li>

                    <vs-divider class="m-1" />
                    <li>
                      <span
                        @click="deleteModalPopUp(slotProps.item.id)"
                        class="cursor-pointer py-3 px-4 block text-danger hover:text-black w-full"
                      >
                        <feather-icon icon="TrashIcon" svgClasses="w-4 h-4" />
                        <span class="ml-2">{{ $t("Eliminar") }}</span>
                      </span>
                    </li>
                  </ul>
                </vs-dropdown-menu>
              </vs-dropdown>
            </div>
          </template>
          <template v-slot:active="slotProps">
            <feather-icon
              icon="CheckCircleIcon"
              svgClasses="w-5 h-5 text-success hover:text-black stroke-current"
              @click="deactiveModalPopUp(slotProps.item.id)"
            />
          </template>
          <template v-slot:deactive="slotProps">
            <feather-icon
              icon="XCircleIcon"
              svgClasses="w-5 h-5 text-danger hover:text-black stroke-current"
              @click="activeModalPopUp(slotProps.item.id)"
            />
          </template>
        </table-data-grid>
        <vs-popup
          :title="$t('popUps.EditPopUp')"
          class="popup-w-900"
          v-if="openModal"
          :active.sync="popupEditPopUp"
        >
          <edit-pop-up :popUp="itemPopUp"></edit-pop-up>
        </vs-popup>

        <vs-popup
          :title="$t('popUps.InfoPopUp')"
          class="popup-w-900"
          v-if="openModalDetail"
          :active.sync="popupSeePopUp"
        >
          <see-pop-up :popUp="itemPopUp"></see-pop-up>
        </vs-popup>
      </div>
    </div>
  </div>
</template>

<script>
import TableDataGrid from "../components/TableDataGrid";
import GenerateQr from "../components/GenerateQr";
import NewPopUp from "@/components/PopUps/NewPopUp";
import EditPopUp from "@/components/PopUps/EditPopUp";
import SeePopUp from "@/components/PopUps/SeePopUp";
import { mapActions, mapGetters, mapMutations } from "vuex";

export default {
  components: {
    TableDataGrid,
    GenerateQr,

    NewPopUp,
    EditPopUp,
    SeePopUp,
  },
  data() {
    return {
      dialog: false,

      dataColumns: [
        { caption: "ID", visible: false },
        { caption: "linkEdit", visible: false },
        {
          caption: this.$t("Imagen"),
          dataType: "image",
          visible: true,
          width: 170,
        },
        {
          dataField: "active",
          caption: this.$t("Activo"),
          dataType: "slot",
          visible: true,
          width: 75,
        },
        {
          dataField: "url",
          caption: this.$t("url"),
          visible: true,
          width: 200,
        },
        {
          dataField: "started_at",
          caption: this.$t("Desde"),
          visible: false,
          width: 600,
        },
        {
          dataField: "finished_at",
          caption: this.$t("Hasta"),
          visible: false,
          width: 600,
        },

        /*
        {caption: this.$t('Imagen'), dataType: 'image', visible: true, width: 175},
        {dataField: 'active', caption: this.$t('Activo'), dataType: 'slot', visible: true, width: 75},
        */
        { caption: "Slug", dataType: "text", visible: false },
      ],
    };
  },
  created() {
    this.refreshPopUps({ restaurant_id: null });
  },
  computed: {
    ...mapGetters({
      languages: "getLanguages",

      language: "getCurrentLanguage",

      itemPopUp: "getPopUp",
      itemsPopUp: "getPopUps",
      currentRestaurant: "getCurrentRestaurant",
    }),
    popupNewPopUp: {
      get() {
        return this.$store.getters.getpopupNewPopUp;
      },
      set(val) {
        this.$store.commit("setpopupNewPopUp", val);
      },
    },
    popupEditPopUp: {
      get() {
        return this.$store.getters.getpopupEditPopUp;
      },
      set(val) {
        this.$store.commit("setpopupEditPopUp", val);
      },
    },
    popupSeePopUp: {
      get() {
        return this.$store.getters.getpopupSeePopUp;
      },
      set(val) {
        this.$store.commit("setpopupSeePopUp", val);
      },
    },
    openModal() {
      if (
        this.popupEditPopUp === true &&
        Object.keys(this.itemPopUp).length > 0
      ) {
        return true;
      }
      return false;
    },

    openModalDetail() {
      if (
        this.popupSeePopUp === true &&
        Object.keys(this.itemPopUp).length > 0
      ) {
        return true;
      }
      return false;
    },

    itemsDataGrid() {
      const items = this.itemsPopUp;

      const results = [];
      const placeholder = process.env.VUE_APP_IMAGE_PLACEHOLDER;

      items.forEach((item, index) => {
        let dateStringStart = "";
        let dateStringEnd = "";
        if (!items[index].started_at) {
          dateStringStart = "No tiene fecha de comienzo";
        } else {
          dateStringStart = items[index].started_at.replace("/t", "/t/t");
        }
        if (!items[index].finished_at) {
          dateStringEnd = "No tiene fecha de caducidad";
        } else {
          dateStringEnd = items[index].finished_at.replace("/t", "/t/t");
        }

        results[index] = {
          id: items[index].id,
          linkEdit: `edit-pop-up/${items[index].id}`,
          image: `<img src="${items[index].path}" style="width: 175px;" class="product-img" >`,
          active: items[index].active === 1 ? "active" : "deactive",
          url: items[index].url,
          started_at: dateStringStart,
          finished_at: dateStringEnd,
        };
      }, items);

      return results;
    },
  },
  methods: {
    ...mapActions({
      activePopUp: "activePopUp",
      deactivePopUp: "deactivePopUp",
      getPopUp: "getPopUp",
      refreshPopUps: "refreshPopUps",
      deletePopUp: "deletePopUp",
    }),
    ...mapMutations({
      setPopUp: "setItemPopUp",
      loading: "loading",
    }),

    setpopupNewPopUp(val) {
      this.popupNewPopUp = val;
      this.$refs.newPopUpModal.resetForm();
    },
    editPopUp(id) {
      this.setPopUp({});
      this.getPopUp({ id, language: this.language });

      this.popupEditPopUp = true;
    },
    seePopUp(id) {
      this.setPopUp({});
      this.getPopUp({ id, language: this.language });
      this.popupSeePopUp = true;
    },

    deleteModalPopUp(id, name) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("popUps.DeletePopUp"),
        text: this.$t("popUps.DeletePopUpConfirm"),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.deletePopUp({ id });
        },
      });
    },

    activeModalPopUp(id) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "success",
        title: this.$t("popUps.ActivatePopUp"),
        text: this.$t("popUps.ActivatePopUpConfirm"),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.activePopUp({ id });
        },
      });
      //this.refreshPopUps({ restaurant_id: 0 });
    },
    deactiveModalPopUp(id) {
      const aux = this;
      this.$vs.dialog({
        type: "confirm",
        color: "danger",
        title: this.$t("popUps.DisablePopUp"),
        text: this.$t("popUps.DisablePopUpConfirm"),
        acceptText: this.$t("Aceptar"),
        cancelText: this.$t("Cancelar"),
        accept() {
          aux.deactivePopUp({ id });
        },
      });
      //this.refreshPopUps({ restaurant_id: 0 });
    },
  },
};
</script>

<style></style>
